import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const analysts = [
  {
    id: 1,
    nameKey: 'analyst1_name',
    roleKey: 'analyst1_role',
    descKey: 'analyst1_desc',
    expKey: 'analyst1_exp',
    clientsKey: 'analyst1_clients',
    img: 'https://static.readdy.ai/image/5490f3a4ad0e9eb55a0769efce385370/f4312741e15b4c57f2cbf5864dad409f.jpeg',
    link: 'https://nikolayiliev.cc',
  },
  {
    id: 2,
    nameKey: 'analyst2_name',
    roleKey: 'analyst2_role',
    descKey: 'analyst2_desc',
    expKey: 'analyst2_exp',
    clientsKey: 'analyst2_clients',
    img: 'https://static.readdy.ai/image/5490f3a4ad0e9eb55a0769efce385370/3618ca02f879f040a7163e23090dc671.jpeg',
    link: 'https://dimitarstoyanov.cc',
  },
  {
    id: 3,
    nameKey: 'analyst3_name',
    roleKey: 'analyst3_role',
    descKey: 'analyst3_desc',
    expKey: 'analyst3_exp',
    clientsKey: 'analyst3_clients',
    img: 'https://static.readdy.ai/image/5490f3a4ad0e9eb55a0769efce385370/497cc50cca49ce4f64090ad3bb539f5e.jpeg',
    link: 'https://ivanstoyanov.cc',
  },
  {
    id: 4,
    nameKey: 'analyst4_name',
    roleKey: 'analyst4_role',
    descKey: 'analyst4_desc',
    expKey: 'analyst4_exp',
    clientsKey: 'analyst4_clients',
    img: 'https://static.readdy.ai/image/5490f3a4ad0e9eb55a0769efce385370/40a6e72713dab778021be083ae7ab68d.jpeg',
    link: 'https://miglenastaneva.cc',
  },
  {
    id: 5,
    nameKey: 'analyst5_name',
    roleKey: 'analyst5_role',
    descKey: 'analyst5_desc',
    expKey: 'analyst5_exp',
    clientsKey: 'analyst5_clients',
    img: 'https://static.readdy.ai/image/5490f3a4ad0e9eb55a0769efce385370/90496d88132edd87e81ae3408552fadc.jpeg',
    link: 'https://nikolasstanev.cc',
  },
  {
    id: 6,
    nameKey: 'analyst6_name',
    roleKey: 'analyst6_role',
    descKey: 'analyst6_desc',
    expKey: 'analyst6_exp',
    clientsKey: 'analyst6_clients',
    img: 'https://static.readdy.ai/image/5490f3a4ad0e9eb55a0769efce385370/3d9e5521af924f57580ce41d38a4f5bd.jpeg',
    link: 'https://stefanminchev.cc',
  },
];

const LANGUAGES = [
  { code: 'bg', label: 'БГ', full: 'Български' },
  { code: 'ru', label: 'РУ', full: 'Русский' },
  { code: 'en', label: 'EN', full: 'English' },
  { code: 'ar', label: 'AR', full: 'العربية' },
];

export default function HomePage() {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const isRtl = i18n.language === 'ar';

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  }, [isRtl]);

  const currentLang = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className="min-h-screen bg-white" dir={isRtl ? 'rtl' : 'ltr'}>
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              alt="Brent Oil Logo"
              className="h-12 w-auto"
              src="https://public.readdy.ai/ai/img_res/3a6c061a-f8fd-48e5-905f-6d59213c3076.png"
            />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              BRENT OIL
            </span>
          </div>

          <div className="flex items-center gap-6">
            <a href="#home" className={`text-sm font-medium transition-colors hover:opacity-70 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>{t('nav_home')}</a>
            <a href="#contracts" className={`text-sm font-medium transition-colors hover:opacity-70 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>{t('nav_contracts')}</a>
            <a href="#analysts" className={`text-sm font-medium transition-colors hover:opacity-70 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>{t('nav_analysts')}</a>
            <a href="#benefits" className={`text-sm font-medium transition-colors hover:opacity-70 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>{t('nav_benefits')}</a>
            <a href="#about" className={`text-sm font-medium transition-colors hover:opacity-70 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>{t('nav_about')}</a>

            {/* Language Switcher */}
            <div className="relative">
              <button
                onClick={() => setLangOpen(v => !v)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${isScrolled ? 'border-gray-300 text-gray-800 hover:border-amber-500' : 'border-white/50 text-white hover:border-amber-400'}`}
              >
                <i className="ri-global-line text-base"></i>
                {currentLang.label}
                <i className={`ri-arrow-down-s-line text-base transition-transform ${langOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {langOpen && (
                <div className="absolute top-full mt-2 right-0 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50 min-w-[140px]">
                  {LANGUAGES.map(lang => (
                    <button
                      key={lang.code}
                      onClick={() => { i18n.changeLanguage(lang.code); setLangOpen(false); }}
                      className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap hover:bg-amber-50 ${i18n.language === lang.code ? 'text-amber-600 bg-amber-50' : 'text-gray-700'}`}
                    >
                      <span className="font-bold text-xs w-6">{lang.label}</span>
                      <span>{lang.full}</span>
                      {i18n.language === lang.code && <i className="ri-check-line ml-auto text-amber-600"></i>}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <a
              href="#contact"
              className="px-6 py-2 rounded-full font-medium whitespace-nowrap transition-all bg-amber-500 text-gray-900 hover:bg-amber-600 cursor-pointer"
            >
              {t('nav_contact')}
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-emerald-900 to-amber-800"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 overflow-hidden opacity-20">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-amber-500 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-emerald-500 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full">
                <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></span>
                <span className="text-sm font-medium text-gray-900">{t('hero_badge')}</span>
              </div>
              <div className="space-y-2">
                <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight">{t('hero_title1')}</h1>
                <h1 className="text-6xl lg:text-7xl font-bold text-white leading-tight">{t('hero_title2')}</h1>
                <h1 className="text-7xl lg:text-8xl font-bold text-amber-400 leading-tight">{t('hero_title3')}</h1>
              </div>
              <p className="text-xl text-gray-300 max-w-xl leading-relaxed">{t('hero_subtitle')}</p>
              <div className="flex flex-wrap gap-4">
                <a href="#contracts" className="px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-gray-900 font-semibold rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all whitespace-nowrap cursor-pointer">
                  {t('hero_cta1')}
                </a>
                <a href="#about" className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
                  {t('hero_cta2')}
                </a>
              </div>
            </div>
            <div className="relative h-96 lg:h-[500px]">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-full h-full">
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-32 bg-gradient-to-b from-amber-400/60 to-transparent rounded-full blur-xl animate-pulse"></div>
                  <div className="absolute top-1/4 left-1/3 w-24 h-48 bg-gradient-to-b from-amber-500/40 to-transparent rounded-full blur-lg"></div>
                  <div className="absolute top-1/3 right-1/3 w-20 h-40 bg-gradient-to-b from-amber-600/40 to-transparent rounded-full blur-lg"></div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 w-28 h-56 bg-gradient-to-b from-amber-500/50 to-transparent rounded-full blur-lg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contracts Section */}
      <section id="contracts" className="py-24 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">{t('contracts_title')}</h2>
            <p className="text-xl text-gray-600">{t('contracts_subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Contract 1 */}
            <div className="relative rounded-2xl p-8 transition-all duration-300 hover:scale-105 bg-white border-2 border-amber-400 shadow-lg flex flex-col">
              <div className="mb-6">
                <span className="px-4 py-2 bg-gray-100 text-gray-900 text-sm font-bold rounded-full whitespace-nowrap">{t('contract_basic')}</span>
              </div>
              <div className="mb-4 mt-2">
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-5xl font-bold text-gray-900">3 100</span>
                  <span className="text-2xl text-gray-600">€</span>
                </div>
                <p className="text-gray-500 text-sm">{t('contract_investment')}</p>
              </div>
              <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 border-2 border-emerald-500 rounded-xl p-6 mb-6 text-center">
                <div className="mb-3">
                  <span className="inline-block px-4 py-1 bg-emerald-600 text-white text-xs font-bold rounded-full">{t('contract_yield')} 100%</span>
                </div>
                <p className="text-sm text-gray-700 font-medium mb-2">{t('contract_profit')}</p>
                <p className="text-5xl font-extrabold text-emerald-700 mb-2">+ 3 100 €</p>
                <div className="border-t-2 border-emerald-300 my-3 pt-3">
                  <p className="text-xs text-gray-600 mb-1">{t('contract_total')}</p>
                  <p className="text-3xl font-bold text-gray-900">6 200 €</p>
                </div>
              </div>
              <div className="space-y-4 mb-8 flex-1">
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit1_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit6_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit3_title')}</span></div>
              </div>
              <a href="#contact" className="block w-full py-4 text-center font-bold rounded-lg transition-all whitespace-nowrap cursor-pointer bg-gray-900 text-white hover:bg-gray-800">{t('contract_start')}</a>
            </div>

            {/* Contract 2 */}
            <div className="relative rounded-2xl p-8 transition-all duration-300 hover:scale-105 bg-gradient-to-br from-slate-900 to-gray-800 text-white shadow-2xl flex flex-col">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="px-6 py-2 bg-amber-500 text-gray-900 text-sm font-bold rounded-full whitespace-nowrap">{t('contract_popular')}</span>
              </div>
              <div className="mb-4 mt-6">
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-5xl font-bold text-white">5 200</span>
                  <span className="text-2xl text-gray-300">€</span>
                </div>
                <p className="text-gray-400 text-sm">{t('contract_investment')}</p>
              </div>
              <div className="bg-gradient-to-br from-emerald-900/60 to-emerald-800/60 border-2 border-emerald-400 rounded-xl p-6 mb-6 text-center">
                <div className="mb-3">
                  <span className="inline-block px-4 py-1 bg-emerald-500 text-white text-xs font-bold rounded-full">{t('contract_yield')} 150%</span>
                </div>
                <p className="text-sm text-gray-300 font-medium mb-2">{t('contract_profit')}</p>
                <p className="text-5xl font-extrabold text-emerald-400 mb-2">+ 7 800 €</p>
                <div className="border-t-2 border-emerald-500 my-3 pt-3">
                  <p className="text-xs text-gray-300 mb-1">{t('contract_total')}</p>
                  <p className="text-3xl font-bold text-white">13 000 €</p>
                </div>
              </div>
              <div className="space-y-4 mb-8 flex-1">
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-400"></i><span className="text-sm text-gray-300">{t('benefit1_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-400"></i><span className="text-sm text-gray-300">{t('benefit2_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-400"></i><span className="text-sm text-gray-300">{t('benefit3_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-400"></i><span className="text-sm text-gray-300">{t('benefit4_title')}</span></div>
              </div>
              <a href="#contact" className="block w-full py-4 text-center font-bold rounded-lg transition-all whitespace-nowrap cursor-pointer bg-amber-500 text-gray-900 hover:bg-amber-600">{t('contract_choose')}</a>
            </div>

            {/* Contract 3 */}
            <div className="relative rounded-2xl p-8 transition-all duration-300 hover:scale-105 bg-white border-2 border-gray-900 shadow-lg flex flex-col">
              <div className="mb-6">
                <span className="px-4 py-2 bg-gray-100 text-gray-900 text-sm font-bold rounded-full whitespace-nowrap">{t('contract_pro')}</span>
              </div>
              <div className="mb-4 mt-2">
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-5xl font-bold text-gray-900">8 900</span>
                  <span className="text-2xl text-gray-600">€</span>
                </div>
                <p className="text-gray-500 text-sm">{t('contract_investment')}</p>
              </div>
              <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 border-2 border-emerald-600 rounded-xl p-6 mb-6 text-center">
                <div className="mb-3">
                  <span className="inline-block px-4 py-1 bg-emerald-700 text-white text-xs font-bold rounded-full">{t('contract_yield')} 210%</span>
                </div>
                <p className="text-sm text-gray-700 font-medium mb-2">{t('contract_profit')}</p>
                <p className="text-5xl font-extrabold text-emerald-700 mb-2">+ 18 690 €</p>
                <div className="border-t-2 border-emerald-400 my-3 pt-3">
                  <p className="text-xs text-gray-600 mb-1">{t('contract_total')}</p>
                  <p className="text-3xl font-bold text-gray-900">27 590 €</p>
                </div>
              </div>
              <div className="space-y-4 mb-8 flex-1">
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit1_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit2_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit3_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit5_title')}</span></div>
                <div className="flex items-start gap-3"><i className="ri-check-line text-xl text-amber-600"></i><span className="text-sm text-gray-700">{t('benefit6_title')}</span></div>
              </div>
              <a href="#contact" className="block w-full py-4 text-center font-bold rounded-lg transition-all whitespace-nowrap cursor-pointer bg-gray-900 text-white hover:bg-gray-800">{t('contract_maximize')}</a>
            </div>
          </div>
          <div className="mt-10 text-center">
            <p className="text-gray-500 text-sm">{t('contract_disclaimer')}</p>
          </div>
        </div>
      </section>

      {/* Calculator Section */}
      <section id="calculator" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">{t('calc_title')}</h2>
            <p className="text-xl text-gray-600">{t('calc_subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 shadow-xl border-2 border-amber-200">
              <div className="text-center mb-6">
                <div className="inline-block px-6 py-2 bg-amber-500 text-white font-bold rounded-full mb-4">{t('contract_yield')} 100%</div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{t('calc_basic_label')}</h3>
              </div>
              <div className="space-y-4 bg-white rounded-xl p-6 mb-6">
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_investment')}</span>
                  <span className="text-2xl font-bold text-gray-900">3 100 €</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_yield')}</span>
                  <span className="text-2xl font-bold text-emerald-600">100%</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_profit')}</span>
                  <span className="text-2xl font-bold text-emerald-600">+ 3 100 €</span>
                </div>
                <div className="flex justify-between items-center pt-2">
                  <span className="text-lg font-bold text-gray-900">{t('calc_total')}</span>
                  <span className="text-3xl font-extrabold text-amber-600">6 200 €</span>
                </div>
              </div>
              <div className="bg-emerald-100 rounded-lg p-4 text-center">
                <p className="text-sm text-emerald-800 font-semibold">{t('calc_double')}</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-8 shadow-xl border-2 border-emerald-300 relative">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <span className="px-4 py-1 bg-red-500 text-white text-xs font-bold rounded-full whitespace-nowrap">{t('calc_best')}</span>
              </div>
              <div className="text-center mb-6 mt-2">
                <div className="inline-block px-6 py-2 bg-emerald-600 text-white font-bold rounded-full mb-4">{t('contract_yield')} 150%</div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{t('calc_popular_label')}</h3>
              </div>
              <div className="space-y-4 bg-white rounded-xl p-6 mb-6">
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_investment')}</span>
                  <span className="text-2xl font-bold text-gray-900">5 200 €</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_yield')}</span>
                  <span className="text-2xl font-bold text-emerald-600">150%</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_profit')}</span>
                  <span className="text-2xl font-bold text-emerald-600">+ 7 800 €</span>
                </div>
                <div className="flex justify-between items-center pt-2">
                  <span className="text-lg font-bold text-gray-900">{t('calc_total')}</span>
                  <span className="text-3xl font-extrabold text-emerald-700">13 000 €</span>
                </div>
              </div>
              <div className="bg-emerald-100 rounded-lg p-4 text-center">
                <p className="text-sm text-emerald-800 font-semibold">{t('calc_2_5')}</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-2xl p-8 shadow-xl border-2 border-gray-400">
              <div className="text-center mb-6">
                <div className="inline-block px-6 py-2 bg-gray-800 text-white font-bold rounded-full mb-4">{t('contract_yield')} 210%</div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{t('calc_max_label')}</h3>
              </div>
              <div className="space-y-4 bg-white rounded-xl p-6 mb-6">
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_investment')}</span>
                  <span className="text-2xl font-bold text-gray-900">8 900 €</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_yield')}</span>
                  <span className="text-2xl font-bold text-emerald-600">210%</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                  <span className="text-gray-600 font-medium">{t('calc_profit')}</span>
                  <span className="text-2xl font-bold text-emerald-600">+ 18 690 €</span>
                </div>
                <div className="flex justify-between items-center pt-2">
                  <span className="text-lg font-bold text-gray-900">{t('calc_total')}</span>
                  <span className="text-3xl font-extrabold text-gray-900">27 590 €</span>
                </div>
              </div>
              <div className="bg-gray-200 rounded-lg p-4 text-center">
                <p className="text-sm text-gray-800 font-semibold">{t('calc_3x')}</p>
              </div>
            </div>
          </div>

          <div className="mt-16 bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl p-12 text-center text-white">
            <h3 className="text-4xl font-bold mb-4">{t('calc_cta_title')}</h3>
            <p className="text-xl mb-8 opacity-90">{t('calc_cta_sub')}</p>
            <a href="#contact" className="inline-block px-10 py-4 bg-white text-amber-600 font-bold text-lg rounded-full hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer">
              {t('calc_cta_btn')}
            </a>
          </div>
        </div>
      </section>

      {/* Analysts Section */}
      <section id="analysts" className="py-24 bg-gradient-to-b from-slate-900 to-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/20 border border-amber-500/40 rounded-full mb-6">
              <span className="w-2 h-2 bg-amber-400 rounded-full animate-pulse"></span>
              <span className="text-amber-400 text-sm font-semibold tracking-widest uppercase">{t('analysts_badge')}</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-4">
              {t('analysts_title')}{' '}
              <span className="text-amber-400 italic">{t('analysts_title_accent')}</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">{t('analysts_subtitle')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {analysts.map((analyst) => (
              <div
                key={analyst.id}
                className="group relative bg-gradient-to-b from-gray-800 to-gray-900 rounded-2xl overflow-hidden border border-gray-700 hover:border-amber-500/60 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-amber-500/10"
              >
                {/* Photo */}
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={analyst.img}
                    alt={t(analyst.nameKey)}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/20 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex items-center gap-2">
                      <span className="px-3 py-1 bg-amber-500 text-gray-900 text-xs font-bold rounded-full whitespace-nowrap">
                        {t(analyst.expKey)}
                      </span>
                      <span className="px-3 py-1 bg-emerald-600/80 text-white text-xs font-bold rounded-full whitespace-nowrap">
                        {t(analyst.clientsKey)}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Info */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-1">{t(analyst.nameKey)}</h3>
                  <p className="text-amber-400 text-sm font-semibold mb-3">{t(analyst.roleKey)}</p>
                  <p className="text-gray-400 text-sm leading-relaxed mb-6">{t(analyst.descKey)}</p>

                  <a
                    href={analyst.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 w-full py-3 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-gray-900 font-bold text-sm rounded-xl transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-user-line text-base"></i>
                    {t('analyst_contact')} {t(analyst.nameKey).split(' ')[0]}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="py-24 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">{t('benefits_title')}</h2>
            <p className="text-xl text-gray-600">{t('benefits_subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-line-chart-line', color: 'amber', titleKey: 'benefit1_title', descKey: 'benefit1_desc' },
              { icon: 'ri-shield-check-line', color: 'emerald', titleKey: 'benefit2_title', descKey: 'benefit2_desc' },
              { icon: 'ri-team-line', color: 'orange', titleKey: 'benefit3_title', descKey: 'benefit3_desc' },
              { icon: 'ri-time-line', color: 'teal', titleKey: 'benefit4_title', descKey: 'benefit4_desc' },
              { icon: 'ri-global-line', color: 'amber', titleKey: 'benefit5_title', descKey: 'benefit5_desc' },
              { icon: 'ri-bar-chart-box-line', color: 'emerald', titleKey: 'benefit6_title', descKey: 'benefit6_desc' },
            ].map((b, i) => (
              <div key={i} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className={`w-16 h-16 bg-${b.color}-100 rounded-xl flex items-center justify-center mb-6`}>
                  <i className={`${b.icon} text-3xl text-${b.color}-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{t(b.titleKey)}</h3>
                <p className="text-gray-600 leading-relaxed">{t(b.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative h-[500px] bg-slate-900 rounded-2xl overflow-hidden">
              <img
                alt="Conflict map"
                className="absolute inset-0 w-full h-full object-cover opacity-60"
                src="https://brentnikolayiliev.com/78947743482dc10855d20c161ca58703.jpg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>
              <div className="absolute bottom-8 left-8 right-8 text-white">
                <h3 className="text-3xl font-bold mb-4">{t('about_map_title')}</h3>
                <div className="flex items-baseline gap-2">
                  <span className="text-6xl font-bold text-red-500">20%</span>
                  <span className="text-xl text-gray-300">{t('about_map_sub')}</span>
                </div>
              </div>
            </div>
            <div className="space-y-8">
              <div className="space-y-4">
                <h2 className="text-5xl font-bold text-gray-900 leading-tight">{t('about_title')}</h2>
                <div className="w-20 h-1 bg-amber-500"></div>
              </div>
              <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
                <p>{t('about_p1')}</p>
                <p>{t('about_p2')}</p>
                <p>{t('about_p3')}</p>
              </div>
              <a href="#contracts" className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white font-semibold rounded-full hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer">
                {t('about_cta')}
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <h2 className="text-5xl font-bold text-gray-900 leading-tight">{t('contact_title')}</h2>
                <div className="w-20 h-1 bg-amber-500"></div>
                <p className="text-xl text-gray-600 leading-relaxed">{t('contact_subtitle')}</p>
              </div>
              <div className="space-y-6">
                <div className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-md">
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-2xl text-amber-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">{t('contact_hours')}</h3>
                    <p className="text-gray-600">{t('contact_hours_weekdays')}</p>
                    <p className="text-gray-600">{t('contact_hours_saturday')}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-md">
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-amber-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">{t('contact_security')}</h3>
                    <p className="text-gray-600">{t('contact_security_desc')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-900 via-slate-800 to-amber-900 rounded-2xl shadow-2xl p-10 flex flex-col items-center text-center space-y-8">
              <div className="w-20 h-20 bg-amber-500/20 rounded-full flex items-center justify-center">
                <i className="ri-team-line text-4xl text-amber-400"></i>
              </div>
              <div className="space-y-3">
                <h3 className="text-3xl font-bold text-white">{t('contact_team_title')}</h3>
                <p className="text-amber-400 font-semibold text-lg">{t('contact_team_sub')}</p>
                <p className="text-gray-300 leading-relaxed">{t('contact_team_desc')}</p>
              </div>

              {/* Analyst preview cards */}
              <div className="w-full grid grid-cols-3 gap-3">
                {analysts.slice(0, 6).map((analyst) => (
                  <a
                    key={analyst.id}
                    href={analyst.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex flex-col items-center gap-2 p-3 bg-white/5 hover:bg-amber-500/20 border border-white/10 hover:border-amber-500/60 rounded-xl transition-all cursor-pointer"
                  >
                    <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-amber-500/40 group-hover:border-amber-400 transition-all flex-shrink-0">
                      <img src={analyst.img} alt={t(analyst.nameKey)} className="w-full h-full object-cover object-top" />
                    </div>
                    <p className="text-white text-xs font-semibold leading-tight text-center">{t(analyst.nameKey).split(' ')[0]}</p>
                    <p className="text-amber-400 text-xs leading-tight text-center opacity-80">{t(analyst.roleKey).split(' ').slice(0, 2).join(' ')}</p>
                  </a>
                ))}
              </div>

              <div className="w-full space-y-4">
                <a
                  href="#analysts"
                  className="w-full flex items-center justify-center gap-3 py-4 px-8 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white font-bold text-lg rounded-xl transition-all shadow-lg hover:shadow-amber-500/30 hover:scale-105 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-user-search-line text-xl"></i>
                  {t('contact_choose_analyst_btn')}
                </a>
                <p className="text-gray-400 text-sm">{t('contact_choose_analyst_sub')}</p>
              </div>

              <div className="flex items-center gap-6 pt-2">
                <div className="text-center">
                  <p className="text-2xl font-bold text-amber-400">6</p>
                  <p className="text-gray-400 text-xs">{t('contact_stat_analysts')}</p>
                </div>
                <div className="w-px h-10 bg-gray-600"></div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-amber-400">880+</p>
                  <p className="text-gray-400 text-xs">{t('contact_stat_clients')}</p>
                </div>
                <div className="w-px h-10 bg-gray-600"></div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-amber-400">210%</p>
                  <p className="text-gray-400 text-xs">{t('contact_stat_yield')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-slate-900 to-gray-800 text-white py-16 relative overflow-hidden">
        <div className="absolute bottom-0 left-0 right-0 text-9xl font-bold text-white/5 text-center pb-8">BRENT OIL</div>
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div className="space-y-4">
              <h3 className="text-2xl font-bold mb-6">{t('contact_title')}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{t('footer_tagline')}</p>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-6">{t('footer_nav')}</h4>
              <ul className="space-y-3">
                {['nav_home','nav_contracts','nav_calculator','nav_analysts','nav_benefits','nav_about','nav_contact'].map(key => (
                  <li key={key}>
                    <a href={`#${key.replace('nav_','')}`} className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">{t(key)}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-6">{t('footer_social')}</h4>
              <div className="space-y-4">
                <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i><span>Instagram</span>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  <i className="ri-linkedin-line text-xl"></i><span>LinkedIn</span>
                </a>
                <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  <i className="ri-facebook-line text-xl"></i><span>Facebook</span>
                </a>
              </div>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-6">{t('footer_contact')}</h4>
              <div className="space-y-4">
                <p className="text-gray-400 text-sm leading-relaxed">{t('footer_contact_desc')}</p>
                <a href="https://nikolayiliev.cc" target="_blank" rel="noopener noreferrer" className="inline-block text-amber-400 hover:text-amber-300 font-semibold transition-colors cursor-pointer">nikolayiliev.cc</a>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm">{t('footer_rights')}</p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">{t('footer_terms')}</a>
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">{t('footer_privacy')}</a>
              </div>
            </div>
            <p className="text-gray-500 text-xs mt-4 text-center md:text-left">{t('footer_disclaimer')}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
